import { useEffect, useState } from "react";
import { Header } from "../../elements/header/Header";
import { requestJSONBy } from "../../functions/api/fetcher";
import { useSearchParams } from "react-router-dom";
import "./channel.css";
import Video from "../../elements/video-preview/video";

export default function ChannelPage() {
    const [currChannel, setCurrChannel] = useState(0);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        const channelId = searchParams.get("id");
        if (channelId !== null) {
            requestJSONBy(`/api/v1/get_channel.php?id=${channelId}`, (data) => {
                setCurrChannel(data.channel);
            }, () => {
                setCurrChannel(null);
            })
        } else {
            setCurrChannel(null);
        }
    }, [searchParams])

    return <>
        <Header />
        {currChannel !== 0 && currChannel !== null && <>
            <div className="channel-header">
                <img src={currChannel.avatar || "/images/white/account/avatar.jpg"} alt={currChannel.title}/>
                <div className="channel-header-info">
                    <h1>{currChannel.title}{currChannel.verified? <img className="channel-verifed-tick" alt="verified" src="/images/white/account/verified.svg" />: ""}</h1>
                    <h3>{currChannel.subscribers} подписчиков</h3>
                </div>
            </div>
            
            <div className="gallery">
                <VideosList videos={currChannel.videos} />
            </div>
        </>}
    </>
}

function VideosList({videos}) {
    return <>
      {
        videos.map(element => {
          return <Video video={element} />
        })
      }
    </>
  }
  